/* eslint prefer-destructuring: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { useSpring, animated } from 'react-spring';
import { Transition } from 'react-spring/renderprops.cjs';

import {
  TOOLTIP_CLASS_NAME as CLASSNAME,
  TOOLTIP_HORIZONTAL_POSITIONS,
  TOOLTIP_VERTICAL_POSITIONS,
} from './constants';

import styles from './tooltip_container.scss';

const sharedVariables = {
  TOOLTIP_HEIGHT: _.parseInt(styles.TOOLTIP_HEIGHT),
  TOOLTIP_WIDTH: _.parseInt(styles.TOOLTIP_WIDTH),
  TOOLTIP_WIDTH_MAX: _.parseInt(styles.TOOLTIP_WIDTH_MAX),
};

const TooltipContainer = ({
  children,
  className,
  containerHeight,
  containerWidth,
  isOpen,
  paddingHorizontalRemoval,
  paddingVerticalRemoval,
  parentRef,
  withArrow,
  ...props
}) => {
  let positionHorizontal;
  let positionVertical;

  if (props.positionHorizontal && props.positionVertical) {
    positionHorizontal = props.positionHorizontal;
    positionVertical = props.positionVertical;
  } else {
    const position = _.invoke(parentRef, 'current.getBoundingClientRect');

    const isEnoughWidthSpace =
      containerWidth -
        (_.get(position, 'right') - _.get(position, 'width', 0) + paddingHorizontalRemoval) <=
      sharedVariables.TOOLTIP_WIDTH_MAX;
    const isEnoughHeightSpace =
      containerHeight -
        (_.get(position, 'top') + _.get(position, 'height', 0) + paddingVerticalRemoval) >=
      sharedVariables.TOOLTIP_HEIGHT;

    positionHorizontal = isEnoughWidthSpace
      ? TOOLTIP_HORIZONTAL_POSITIONS.RIGHT
      : TOOLTIP_HORIZONTAL_POSITIONS.LEFT;

    positionVertical = isEnoughHeightSpace
      ? TOOLTIP_VERTICAL_POSITIONS.BOTTOM
      : TOOLTIP_VERTICAL_POSITIONS.TOP;
  }

  const animateTooltip = useSpring({ opacity: isOpen ? 1 : 0, delay: 0, config: { duration: 10 } });

  return (
    <Transition
      config={{ duration: 100 }}
      duration={100}
      enter={{ opacity: 1 }}
      from={{ opacity: 0 }}
      items={isOpen}
      leave={{ opacity: 0 }}
      native
    >
      {show =>
        show &&
        (transitionProps => (
          <animated.div
            style={{ ...transitionProps, ...animateTooltip }}
            className={classnames(`${CLASSNAME}__tooltip`, className, {
              [`-position-${positionHorizontal}`]: positionHorizontal,
              [`-position-${positionVertical}`]: positionVertical,
              '-with-arrow': withArrow,
            })}
          >
            {withArrow && <div className={`${CLASSNAME}__tooltip-arrow`} />}
            {children}
          </animated.div>
        ))
      }
    </Transition>
  );
};

TooltipContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  containerHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  isOpen: PropTypes.bool,
  paddingHorizontalRemoval: PropTypes.number,
  paddingVerticalRemoval: PropTypes.number,
  parentRef: PropTypes.shape({}),
  positionHorizontal: PropTypes.string,
  positionVertical: PropTypes.string,
  withArrow: PropTypes.bool,
};

TooltipContainer.defaultProps = {
  isOpen: false,
  paddingHorizontalRemoval: 0,
  paddingVerticalRemoval: 0,
  parentRef: {},
};

export default TooltipContainer;
